import React from 'react';

import Grid from '@mui/material/Grid';
import Stack from '@mui/material/Stack';

import { isFeatureEnabled } from 'ff/common/ffAppUtils';
import {
    constructFlightEvents,
    durationSecondsToString,
    formatDistance,
    formatGroundSpeed,
} from 'ff/debrief/utils';
import { useCurrentTracklog, useCurrentDebrief } from 'ff/debrief/hooks';
import ActionRow from 'ff/debrief/components/details/ActionRow';
import FlightEvents from 'ff/debrief/components/details/FlightEvents';
import TerminalDetails from 'ff/debrief/components/details/TerminalDetails';
import MetaDataItem from 'ff/debrief/components/details/MetaDataItem';
import TerminalDetailsWithScore from 'ff/debrief/components/details/TerminalDetailsWithScore';

const TracklogDetails = () => {
    const {
        tracklog: tl,
        trimmedValues: tv,
        currentTracklog: ctl,
        isLoaded,
        hasCloudAhoyDebrief,
    } = useCurrentTracklog();
    const { debrief, queryStatus } = useCurrentDebrief();
    const flightEvents = constructFlightEvents(ctl, debrief);

    const showDebrief =
        isFeatureEnabled('debrief_features') && hasCloudAhoyDebrief;

    const col1Width = showDebrief ? 4 : 3;
    const col2Width = 12 - col1Width;

    if (!isLoaded) {
        return null;
    }
    return (
        <Grid
            columns={12}
            flexGrow={1}
            padding={2.5}
            columnSpacing={2.5}
            container
        >
            <Grid item xs={col1Width}>
                {showDebrief ? (
                    <TerminalDetailsWithScore
                        origin={tl?.derivedOrigin}
                        dest={tl?.derivedDestination}
                        start={tv?.timestampStart}
                        end={tv?.timestampEnd}
                        score={debrief?.score}
                        {...queryStatus}
                    />
                ) : (
                    <TerminalDetails
                        origin={tl?.derivedOrigin}
                        dest={tl?.derivedDestination}
                        start={tv?.timestampStart}
                        end={tv?.timestampEnd}
                    />
                )}
            </Grid>
            <Grid xs={col2Width} columns={12} rowGap={3} item container>
                <Grid item xs="auto">
                    <Stack direction="row" spacing={3}>
                        <MetaDataItem label="Aircraft">
                            {tl?.tailNumber}
                        </MetaDataItem>
                        <MetaDataItem label="Total Time">
                            {durationSecondsToString(tv?.totalDurationSeconds)}
                        </MetaDataItem>
                        <MetaDataItem label="Avg Ground Speed">
                            {formatGroundSpeed(tv?.avgGndspd)}
                        </MetaDataItem>
                        <MetaDataItem label="Distance">
                            {formatDistance(tv?.distTotal)}
                        </MetaDataItem>
                    </Stack>
                </Grid>
                <Grid item xs>
                    <ActionRow />
                </Grid>
                <Grid item minHeight="63px" xs={12}>
                    <FlightEvents events={flightEvents} />
                </Grid>
            </Grid>
        </Grid>
    );
};

export default TracklogDetails;
